
function PopupLogin() {
  return <div className="popup-login"></div>;
}

export default PopupLogin;
